import React from 'react';
import Input from '../general/Input';

const Esid = props => {
  return (
    <div class="esid relative bg-white">
      <div class="max-w-7xl mx-auto flex justify-center">
        <div class="pb-10 locate">
          <p class="pt-6 text-center font-medium max-w-5xl mx-auto text-black sm:text-lg md:text-2xl">
            Find my ESID from address
          </p>
          <div class="mx-auto max-w-xl">
            <form class="mt-4 flex rounded-md" onSubmit={e => e.preventDefault()}>
              <div class="relative flex items-stretch flex-grow focus-within:z-10">
                <Input
                  onChange={e => props.handleChange('address', e.target.value)}
                  id="address"
                  className="py-4 form-input block w-full rounded-l-md pl-8 text-xl transition ease-in-out duration-150 sm:text-sm sm:leading-5 focus:shadow-none focus:outline-none"
                  placeholder="Address"
                  type="text"
                  error={props.errors.address}
                />
              </div>
              <button
                type="submit"
                onClick={
                  props.distributionPoint
                    ? props.resetDistributionPoint
                    : props.getDistributionPointsByAddress
                }
                class=" ml-2 relative py-2 leading-5 font-medium rounded-md text-white text-black bg-yellow hover:text-white hover:bg-black focus:outline-none focus:shadow-outline-black focus:border-black-300 active:bg-gray-100 active:text-gray-700 transition ease-in-out duration-150"
              >
                <span class="pr-16 pl-16 underline">
                  {props.distributionPoint ? 'Reset Field' : 'Find Me'}
                </span>
              </button>
            </form>
          </div>
        </div>

        <div class="ml-10 pb-10 locate">
          <p class="pt-6 text-center font-medium max-w-5xl mx-auto text-black sm:text-lg md:text-2xl">
            Find my address from ESID
          </p>
          <div class="mx-auto max-w-xl">
            <form class="mt-4 flex rounded-md" onSubmit={e => e.preventDefault()}>
              <div class="relative flex items-stretch flex-grow focus-within:z-10">
                <Input
                  onChange={e => props.handleChange('esid', e.target.value)}
                  id="esid"
                  className="py-4 form-input block w-full rounded-l-md pl-8 text-xl transition ease-in-out duration-150 sm:text-sm sm:leading-5 focus:shadow-none focus:outline-none"
                  placeholder="ESID #"
                  type="number"
                  error={props.errors.address}
                />
              </div>
              <button
                type="submit"
                onClick={
                  props.distributionPoint
                    ? props.resetDistributionPoint
                    : props.getDistributionPointsByAddress
                }
                class=" ml-2 relative py-2 leading-5 font-medium rounded-md text-white text-black bg-yellow hover:text-white hover:bg-black focus:outline-none focus:shadow-outline-black focus:border-black-300 active:bg-gray-100 active:text-gray-700 transition ease-in-out duration-150"
              >
                <span class="pr-16 pl-16 underline">
                  {props.distributionPoint ? 'Reset Field' : 'Find ESID'}
                </span>
              </button>
            </form>
          </div>
        </div>
      </div>

      {props.distributionPoints && !props.distributionPoint && props.distributionPoints.length > 0 && (
        <p class=" pt-7 pb-7 font-medium text-center bg-yellow mx-auto text-black sm:text-lg md:text-2xl">
          <span class="font-bold mr-2 bg-white px-4 py-3 rounded-zip">
            {props.distributionPoints.length}
          </span>{' '}
          addresses found in Texas from that city:
        </p>
      )}
      <div class="list bg-gray-50">
        {props.distributionPoints &&
          !props.distributionPoint &&
          props.distributionPoints.map(distributionPoint => (
            <div class="bg-white hover:bg-gray-100 transition ease-in-out duration-150">
              <div class="border-b w-3/4 mx-auto"></div>
              <div class="mx-auto md:grid md:grid-cols-5 md:gap-2">
                <div class="block"></div>
                <div class="pt-3 col-span-2 mt-4 mb-6">
                  <div class="">
                    <p class="font-medium inline pl-2 text-2xl">
                      {distributionPoint.address1},{' '}
                      <span class="text-yellow font-bold">{distributionPoint.city}</span>
                    </p>
                  </div>
                </div>{' '}
                <span class="inline-flex rounded-md">
                  <button
                    onClick={() => props.setDistributionPoint(distributionPoint)}
                    type="button"
                    class="mt-2 mx-auto mb-2 px-3 py-2 border border-transparent text-xs leading-4 font-medium rounded text-white bg-yellow hover:bg-darkYellow focus:outline-none focus:border-yellow focus:shadow-outline-yellow active:bg-yellow transition ease-in-out duration-150"
                  >
                    Select This Address
                  </button>
                </span>
              </div>
            </div>
          ))}
        {props.distributionPoint && (
          <div>
            <div class="max-w-6xl mx-auto border border-t"></div>
            <div class="bg-white text-center py-10 font-medium flex  justify-center">
              <div class="max-w-4xl">
                <p class="inline text-gray-400 text-xl">Your ESID & Address:</p>
                <br></br>
                <p class="bg-black px-6 text-yellow rounded-md inline font-bold pb-2 text-3xl tracking-wide">
                  123456897
                </p>
                <p class="inline text-3xl px-2 font-light text-gray-600"> | </p>
                <p class="inline text-3xl">
                  {props.distributionPoint.address1},{' '}
                  <span class="text-yellow font-bold">
                    {' '}
                    {props.distributionPoint.city}, {props.distributionPoint.stateCode},{' '}
                    {props.distributionPoint.zipCode}
                  </span>{' '}
                </p>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Esid;

/*   <p class="inline pl-2 text-2xl">{props.distributionPoint.address1}, {props.distributionPoint.city}, {props.distributionPoint.stateCode}, {props.distributionPoint.zipCode} </p>*/
